/**
 * AttributeStatsCard.js
 *
 * Displays how many of a team's items have each value of an attribute
 * (e.g. how many movies of each Actor), with that attribute's limits.
 */

import React, { useMemo } from "react";
import Card, { CardHeader, CardTitle, CardContent } from "../../../components/ui/Card";

const AttributeStatsCard = ({ attribute, items, rule }) => {
    const stats = useMemo(() => {
        const counts = Object.fromEntries(attribute.values.map((value) => [value, 0]));
        items?.forEach((item) => {
            const value = item.values?.[attribute.name];
            if (value !== undefined && value !== "") counts[value] = (counts[value] || 0) + 1;
        });
        return Object.entries(counts).sort((a, b) => b[1] - a[1]);
    }, [attribute, items]);

    const hasMax = rule?.maxPerValue !== null && rule?.maxPerValue !== undefined;

    return (
        <Card className="bg-zinc-900 border-zinc-700 shadow-md">
            <CardHeader className="pb-2 text-left">
                <CardTitle className="text-sm text-zinc-400">{attribute.name} Statistics</CardTitle>
            </CardHeader>
            <CardContent className="flex flex-col divide-y divide-zinc-700">
                {stats.map(([value, count]) => (
                    <div key={value} className="flex justify-between py-3">
                        <span className={`text-lg font-medium ${count > 0 ? "text-zinc-200" : "text-zinc-500"}`}>{value}</span>
                        <span className={`font-bold ${count > 0 ? "text-yellow" : "text-zinc-600"}`}>
                            {count}{hasMax && <span className="text-zinc-500 font-normal"> / {rule.maxPerValue}</span>}
                        </span>
                    </div>
                ))}
            </CardContent>
        </Card>
    );
};

export default AttributeStatsCard;
